var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEscalated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.596 9.824a4.912 4.912 0 1 0 0-9.824 4.912 4.912 0 0 0 0 9.824Zm3.438 1.228h-.64c-.852.391-1.8.614-2.798.614a6.71 6.71 0 0 1-2.798-.614h-.64A5.159 5.159 0 0 0 0 16.21v1.596c0 1.017.825 1.842 1.842 1.842h11.382a4.74 4.74 0 0 1 .668-8.243 5.039 5.039 0 0 0-1.858-.353Zm6.745 1.79a4.14 4.14 0 0 1 0 5.861 4.144 4.144 0 1 1 0-5.861Zm-2.747 4.926a.256.256 0 0 0 .076-.183v-3.001l1.112 1.113a.263.263 0 0 0 .367 0 .26.26 0 0 0 0-.367l-1.555-1.554a.257.257 0 0 0-.366 0l-1.555 1.554a.26.26 0 0 0 .367.367l1.112-1.113v3.001c0 .069.027.135.076.183a.257.257 0 0 0 .366 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEscalated);
export default __webpack_public_path__ + "static/media/escalated.ec184aab365b45751dacd191d11b28cc.svg";
export { ForwardRef as ReactComponent };